
import { defineComponent } from 'vue'
import Text from './common/Text.vue'

export default defineComponent({
  components: {
    Text,
  },
  data() {
    return {
      previewImage: '',
    }
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    formattedHeader() {
      return this.$t('home.mealManagement.header').replace(/\n/g, '<br>')
    },
    formattedDesc() {
      return this.$t('home.mealManagement.desc').replace(/\n/g, '<br>')
    },
  },
  watch: {
    currentLanguage(newLang) {
      this.updatePreviewImage(newLang)
    },
  },
  methods: {
    updatePreviewImage(lang: string) {
      const assetLang = lang === 'jp' ? 'ja' : lang
      try {
        this.previewImage = require(`@/assets/pages/home/screens/meal-management-${assetLang}.png`)
      } catch (e) {
        this.previewImage = require('@/assets/pages/home/screens/meal-management-en.png')
      }
    },
  },
  created() {
    this.updatePreviewImage(this.currentLanguage)
  },
})
